var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTermBillChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 0C9.75781 0 10.1875 0.429688 10.1875 0.9375V2.5H14.5625V0.9375C14.5625 0.429688 14.9531 0 15.5 0C16.0078 0 16.4375 0.429688 16.4375 0.9375V2.5H18C19.3672 2.5 20.5 3.63281 20.5 5V13.75C20.5 15.1562 19.3672 16.25 18 16.25H6.75C5.34375 16.25 4.25 15.1562 4.25 13.75V5C4.25 3.63281 5.34375 2.5 6.75 2.5H8.3125V0.9375C8.3125 0.429688 8.70312 0 9.25 0ZM6.125 13.75C6.125 14.1016 6.39844 14.375 6.75 14.375H18C18.3125 14.375 18.625 14.1016 18.625 13.75V7.5H6.125V13.75ZM2.375 15.3125C2.375 16.875 3.625 18.125 5.1875 18.125H15.8125C16.3203 18.125 16.75 18.5547 16.75 19.0625C16.75 19.6094 16.3203 20 15.8125 20H5.1875C2.57031 20 0.5 17.9297 0.5 15.3125V7.1875C0.5 6.67969 0.890625 6.25 1.4375 6.25C1.94531 6.25 2.375 6.67969 2.375 7.1875V15.3125Z",
    fill: "#1565C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermBillChecked);
export default __webpack_public_path__ + "static/media/term-bill-checked.3469bc989f5cf32bdaa0235bc67ee05f.svg";
export { ForwardRef as ReactComponent };